import { Component } from 'react';
import styles from './layoutedContentGrid.scss';
import classNames from 'classnames';
import React from 'react';
import DebugBarHelper from '../../../helper/debugBarHelper';
import DebuggerDataSource from '../../debugBar/debuggerDataSource';

interface LayoutedContentGridProps {
    layoutedContentGridKeys: string[], 
    debuggerIsOn: boolean, isRelease: boolean,
    updateLayoutedContentGridState,
    colorCode: number,
}

export default class LayoutedContentGrid extends Component<LayoutedContentGridProps, {}> {
    private debugBarHelper: DebugBarHelper;
    private addLcgGridTimer;
    private lcgContentAvailabilityTimer;

    constructor(props) {
        super(props);

        this.debugBarHelper = DebugBarHelper.instance;
    }

    private static arraysEqual(a: string[], b: string[]): boolean {
        if (a === b) return true; // same reference
        if (!a || !b) return false; // one is null or undefined
        if (a.length !== b.length) return false; // length changed
        return a.every((val, i) => val === b[i]);
    }

    componentDidMount(): void {
        this.addLcgGridTimer = setTimeout(() => {
            this.addLcgGrid();

        }, 1000); // 1000 s needed for LCG assets to be ready
    }

    componentDidUpdate(prevProps: LayoutedContentGridProps): void {
        const keysChanged = !LayoutedContentGrid.arraysEqual(prevProps.layoutedContentGridKeys,
            this.props.layoutedContentGridKeys);
    
        if (prevProps.colorCode !== this.props.colorCode || keysChanged) {
            this.addLcgGrid();
        } else {
            if (this.props.layoutedContentGridKeys && this.props.layoutedContentGridKeys.length <= 0) {
                this.props.updateLayoutedContentGridState(false);
            }
        }
    }

    private addLcgGrid(): void {
        if(!this.props.layoutedContentGridKeys
            || this.props.layoutedContentGridKeys.length <= 0)
            return; // no lcg, leave everything as it is

        const lcgKeysAndStates: {gridId: string; isAvailable: boolean}[] = [];

        this.props.layoutedContentGridKeys.forEach(value => {
            const containerId = 'pdp-lcg-' + value;

            window.shell.publishTo('ESMKT.LayoutedContentGrid.AddLcgGrid',
                {
                    gridId: value, containerId: containerId,
                    callback: {
                        resolve: (value: {gridId: string;}) => {
                            // add the grid to the list of keys and set it as available
                            this.handleLcgAvailabilityResponse(lcgKeysAndStates, value.gridId, true);
                        },
                        reject: (reaseon: {gridId: string;}) => {
                            // add the grid to the list of keys and set it as not available
                            this.handleLcgAvailabilityResponse(lcgKeysAndStates, reaseon.gridId, false);
                        }
                    }
                });
        });
    }

    private handleLcgAvailabilityResponse(lcgKeysAndStates: {gridId: string; isAvailable: boolean}[],
        gridId: string, isAvailable: boolean): void {
        // add the grid to the list of keys and set it as available/ not available:
        lcgKeysAndStates.push({gridId: gridId, isAvailable: isAvailable});

        if(lcgKeysAndStates.length === this.props.layoutedContentGridKeys.length) {
            const stateCondition = (element) => element.isAvailable === true;
            const result = lcgKeysAndStates.some(stateCondition);

            // set the state of the layouted content grid shutter:
            this.props.updateLayoutedContentGridState(result);
        }
    }

    componentWillUnmount(): void {
        clearTimeout(this.addLcgGridTimer);
        clearTimeout(this.lcgContentAvailabilityTimer);
    }

    render() {
        return (
            <div data-testid='layouted-content-grid' data-semantic-id='layouted-content-grid'
                className={classNames(styles.layoutedContentGrid,
                {
                    [this.debugBarHelper.getDebuggerClassName(
                        DebugBarHelper.LayoutedContentGrid_source)]: this.props.debuggerIsOn
                })}>
                {this.props.layoutedContentGridKeys && 
                    (this.props.layoutedContentGridKeys.map((value, index) => {
                        const containerId = 'pdp-lcg-' + value;
                        return (<div key={index} className={styles.gridContent} data-testid='grid-content'
                          data-semantic-id='grid-content'>
                            {!this.props.isRelease &&
                                <DebuggerDataSource value={'Layouted Content Grid source Key: "' + value + '"'}/>
                            }
                            <div id={containerId} data-grid-id={value}></div>
                        </div>)
                    }))}
            </div>
        );
    }
}

